

















import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import ClickOutside from "vue-click-outside";
import {v4 as uuid_v4} from "uuid";
import {STreeItem} from "./dto/STreeItem";
import {SPropTypeEnum} from "./dto/SPropTypeEnum";

@Component({directives: {
    ClickOutside,
  },})
export default class TreePropInputValue extends Vue {
  @Prop() value!: STreeItem;
  @Prop() editable!: boolean;
  private SBOOLEAN: SPropTypeEnum = SPropTypeEnum.SBOOLEAN;
  private SNULL: SPropTypeEnum = SPropTypeEnum.SNULL;
  private modelData: STreeItem = this.value;

  get inputType(){
    if(this.value.propType === SPropTypeEnum.SNUMBER){
      return SPropTypeEnum.SNUMBER;
    }
    return 'text'
  }
  @Watch('modelData')
  watchModelData(newValue: STreeItem){
    this.emitInput(newValue);
  }

  @Emit('input')
  emitInput(value: STreeItem) { return value; }

  clickOutsite(){
    this.activatedPropValueEdit(false);
  }

  @Emit('activated-edit')
  activatedPropValueEdit(newValue: boolean){
    return newValue;
  }

  get genUID(){
    return uuid_v4();
  }



}
